import { PCBV2File } from '@luminovo/http-client';

export const isPcbFilePreviewAvailable = (file: PCBV2File) => {
    return file.lifecycles.find((lifecycle) => lifecycle.name === 'preview')?.status.name === 'success';
};
